import React from 'react';

function FontPreview({ selectedFont, onFontSelect, colours, businessName }) {
  const fonts = [
    { name: 'Open Sans', family: 'Open Sans, sans-serif', type: 'SANS-SERIF' },
    { name: 'Libre Baskerville', family: 'Libre Baskerville, serif', type: 'SERIF' }
  ];

  const primaryColour = colours[0] || '#FF5841';
  const businessNameFirst = businessName.split(' ')[0];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {fonts.map((font) => (
        <button
          key={font.name}
          onClick={() => onFontSelect(font.name)}
          className={`text-left p-6 border-2 rounded-lg transition-all duration-200 hover:shadow-lg ${
            selectedFont === font.name
              ? 'border-[#FF5841] bg-[#FFEDEB]'
              : 'border-gray-300 hover:border-gray-400'
          }`}
          style={{ fontFamily: font.family, fontSize: '15px' }}
        >
          {/* Header */}
          <div className="flex justify-between items-center mb-4 pb-2 border-b border-gray-200">
            <div className="font-bold" style={{ color: primaryColour }}>
              {businessNameFirst.toUpperCase()} LOGO
            </div>
            <div className="hamburger-menu">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Content */}
          <h2 className="text-xl font-bold mb-3" style={{ color: primaryColour }}>
            Welcome to {businessNameFirst}
          </h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            At {businessNameFirst}, we believe in creating value and exceeding expectations. With our dedicated team and proven expertise, we consistently strive to bring you solutions that empower your success.
          </p>
          
          <h3 className="text-lg font-semibold mb-3" style={{ color: primaryColour }}>
            What We Offer
          </h3>
          
          <div className="mb-4">
            <div 
              className="p-3 rounded-lg"
              style={{ backgroundColor: `${primaryColour}10` }}
            >
              <h4 className="font-semibold mb-2 text-16px" style={{ color: primaryColour }}>
                Quality & Reliability
              </h4>
              <ul className="text-15px text-gray-600 space-y-1">
                <li>• Trusted products crafted with care</li>
                <li>• Dedicated customer support team</li>
                <li>• Commitment to timely delivery</li>
              </ul>
            </div>
          </div>
          
          <button 
            className="px-4 py-2 text-white text-16 rounded-lg font-medium"
            style={{ backgroundColor: primaryColour }}
          >
            Contact Us
          </button>

          {/* Font Info */}
          <div className="mt-4 pt-4 border-t border-gray-200 flex justify-between items-center">
            <span className="font-semibold text-gray-900">{font.name}</span>
            <span className="text-xs text-gray-500 font-medium">{font.type}</span>
          </div>
        </button>
      ))}
    </div>
  );
}

export default FontPreview;